// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ActionsCompact-container-1_Gvq {\n  margin-top: auto;\n}\n.ActionsCompact-section-3nUI6 {\n  display: flex;\n  flex-direction: column;\n}\n.ActionsCompact-section-3nUI6 + .ActionsCompact-section-3nUI6 {\n  position: relative;\n  margin-top: 5px;\n  padding-top: 6px;\n}\n.ActionsCompact-section-3nUI6 + .ActionsCompact-section-3nUI6:before {\n  content: '';\n  position: absolute;\n  inset: 0 10px auto;\n  border-top: 1px solid #e0dfde;\n}\n.ActionsCompact-justLaunchedPopover-4i8gu {\n  position: absolute;\n  left: 100%;\n  bottom: 0;\n  width: 180px;\n  margin: 0 0 10px 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "ActionsCompact-container-1_Gvq",
	"section": "ActionsCompact-section-3nUI6",
	"justLaunchedPopover": "ActionsCompact-justLaunchedPopover-4i8gu"
};
module.exports = exports;
